
import {
  SAVE_TO_SHORTLIST,
  RECEIVE_SHORTLIST_RESPONSE,
  INIT_SHORTLIST,
} from "./actionTypes";
import { modalTypes } from "./modalTypes";

export const saveToShortlist = payload => dispatch => {
  dispatch({
    type: SAVE_TO_SHORTLIST,
    payload: payload,
  }).then(response => {
    if (response) {
      const modalTypeId = response.data.modalTypeId;
      payload = { ...payload, modalTypeId };
      dispatch(receiveShortlistResponse(payload));
    }
  })
  .catch(err => { 
    const modalTypeId = err.response && err.response.status === 401 ? modalTypes.UNAUTHORISED : modalTypes.ERROR;
  
    payload = { ...payload, modalTypeId };
    dispatch(receiveShortlistResponse(payload));
  })
};
export const receiveShortlistResponse = payload => dispatch => {
  dispatch({
    type: RECEIVE_SHORTLIST_RESPONSE,
    payload,
  });
};
export const initShortlist = () => (dispatch, getState) => {
  dispatch({
    type: INIT_SHORTLIST,
  });
};
